import deps from "./depsloader";

const yeti = {
    isTouchDevice: false,
    trackingEnabled: false,

    setupTracking: function() {
      const urlSearchParams = new URLSearchParams(window.location.search.substring(1));

      const campaign = urlSearchParams.get("campaign");
      const keyword = urlSearchParams.get("keyword");

      if (campaign || keyword) {
        deps.load("js-cookie").then((Cookies) => {
          Cookies.set("swtracking", JSON.stringify({
            campaign,
            keyword
          }));
        });
      }
    },

    eventCache: [],
    trackEvent: function(category, action, label) {
      if (this.trackingEnabled && window.ga) {
        window.ga("send", "event", category, action, label);

        if (category == "conversion") {
          let event = {
              hitType: "event",
              eventCategory: "conversion_gads_query"
          };

          deps.load("js-cookie").then((Cookies) => {
            const swtracking = Cookies.get("swtracking");
            if (swtracking) {
              const data = JSON.parse(swtracking);

              if ("campaign" in data) {
                event["eventAction"] = data["campaign"];
              }

              if ("keyword" in data) {
                event["eventLabel"] = data["keyword"];
              }

              window.ga("send", event);
            }

            const googleAds = this.googleAds();
            if (googleAds && googleAds.conversionEvent && window.gtag) {
              window.gtag("event", "conversion", {"send_to": googleAds.conversionEvent});
            }
          });
        }
      } else {
        this.eventCache.push({
          category: category,
          action: action,
          label: label
        });
      }
    },

    sendEvents: function() {
      let events = this.eventCache;
      this.eventCache = [];
      events.forEach(event => {
        this.trackEvent(event.category, event.action, event.label);
      })
    },

    enableTracking: function() {
      this.trackingEnabled = true;
      this.sendEvents();
    }
}

const tmp = DOLLAR_YETI_GLOBAL_OVERWRITE; // eslint-disable-line

Object.keys(tmp).forEach(k => {
  yeti[k] = tmp[k];
});

window.addEventListener("touchstart", function onFirstTouch() {
    yeti.isTouchDevice = true;
    window.removeEventListener("touchstart", onFirstTouch, false);
}, false);


let body = document.querySelector("body");
function handleNavScroll() {
  const scrollPosY = window.pageYOffset | document.body.scrollTop;

  if (scrollPosY > 70) {
    body.classList.add("has-scrolled");
  } else {
    body.classList.remove("has-scrolled");
  }
}

window.addEventListener("scroll", () => {
  handleNavScroll();
}, false);

handleNavScroll();

var elements = document.querySelectorAll("#primary-menu > li");
var elms = [];
var defaultElm  = null;
for (let i in elements) {
    let elm = elements[i];
    if (typeof elm !== "object") {
        continue;
    }

    if (elm.className.indexOf("active") != -1 && defaultElm == null) {
        defaultElm = {
            "elm" : elm,
            "offset": 0,
            "offset2": 0
        };
        break;
    }
}

for (let i in elements) {
    let elm = elements[i];
    if (typeof elm !== "object") {
        continue;
    }

    let href = elm.childNodes[0].href;
    if (href.indexOf("#") === -1) {
        continue;
    }

    let target = href.substr(href.indexOf("#"));
    let targetElm = document.getElementById(target.replace("#", ""));
    if (targetElm == null) {
        continue;
    }

    var a = targetElm, c = 0;
    while (a) {
        c += a.offsetTop;
        a = a.offsetParent;
    }

    elms.push({
        "elm" : elm,
        "targetElm": targetElm,
        "offset": c,
        "end": c + targetElm.offsetHeight
    });
}

function deactivateMenu() {
    for (let i in elements) {
        let elm = elements[i];
        if (typeof elm !== "object") {
            continue;
        }

        elm.classList.remove("active", "active-force");
    }
}

function activateMenu(e) {
    deactivateMenu();

    e.elm.classList.add("active-force", "active");
}

window.addEventListener('scroll', function() {
    let offsetTop = window.pageYOffset + (window.innerHeight / 2);
    if (defaultElm) {
        activateMenu(defaultElm);
    } else {
        deactivateMenu();
    }

    for (let k in elms) {
        let e = elms[k];
        if (e.offset < offsetTop) {
            activateMenu(e);
        }
    }
});

export default yeti;
